/**
 * Trim string identity fields; normalize optional internal flags without supplier-specific logic.
 * @param {Record<string, unknown>} pax
 * @returns {Record<string, unknown>}
 */
export function normalizePassengerInput(pax) {
  if (!pax || typeof pax !== "object") return {};
  const out = { ...pax };
  for (const k of ["firstname", "lastname", "email", "cell"]) {
    if (typeof out[k] === "string") out[k] = out[k].trim();
  }
  if (typeof out.gender === "string") out.gender = out.gender.trim();
  return out;
}
